// extracted by mini-css-extract-plugin
module.exports = {"root":"HealthCreateEdit_root__-m5Fv"};